import { AppBar, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(AppBar)(({ theme: { palette, shadows } }) => ({
  backgroundColor: "rgba(255, 255, 255, .5)",
  backdropFilter: "blur(10px)",
  boxShadow: shadows[3],
  color: palette.text.primary,
}));

export const StyledLayout = styled(Stack)({
  height: "100%",
});
